const API_ENDPOINTS = {
    USER_VALIDATE_TOKEN: '/validate-token',
    USER_LOGIN: '/login',
    USER_PROFILE_GET: 'user/profile',
    USER_PROFILE_SAVE: 'user/save-profile',
    USER_UPDATE_PASSWORD: 'user/update-password',

    FILE_UPLOAD: 'file/save',
    FILE_REMOVE: 'file/remove',

    DIAGNOSTIC_LIST: '/diagnostics/list',
    DIAGNOSTIC_SAVE: '/diagnostics/save',
    DIAGNOSTIC_DELETE: '/diagnostics/delete',
    DIAGNOSTIC_DETAIL: '/diagnostics/',
    DIAGNOSTIC_STATUS_TOGGLE: '/diagnostics/status/toggle',

    DIAGNOSTIC_OPTIONS_LIST: '/diagnostics/options/list',

    MASTER_DIAGNOSTIC_LIST: '/diagnostics/master/list',

    DIAGNOSTIC_BOOKING_LIST: '/diagnostics/booking/list',
    DIAGNOSTIC_BOOKING_SAVE: '/diagnostics/booking/save',
    DIAGNOSTIC_BOOKING_DETAIL: '/diagnostics/booking/',
    DIAGNOSTIC_BOOKING_DELETE: '/diagnostics/booking/delete',

    APP_USER_LIST: '/app-user/list',

    ADDRESS_LIST: '/address/list',

    DIAGNOSTIC_BOOKING_ITEMS_LIST: '/diagnostics/booking/items/list',
    DIAGNOSTIC_BOOKING_ITEMS_SAVE: '/diagnostics/booking/items/save',
    DIAGNOSTIC_BOOKING_ITEMS_DETAIL: '/diagnostics/booking/items/',
    DIAGNOSTIC_BOOKING_ITEMS_DELETE: '/diagnostics/booking/items/delete',

};

export default API_ENDPOINTS;
